import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import {
  PageTitleStyled as PageTitle,
  IconStyled,
  PageHeadingStyled as PageHeading,
} from './styles/PageNavStyled';
import { ReactComponent as ArrowLeft } from '../../../images/arrow-left.svg';
import AppContext from '../../App/AppContext';
import PageContext from '../../../contextProvider/PageContext';

const NavChevron = ({ title, level, directURL, onClick, redirect, size }) => {
  const { location } = useContext(PageContext);

  const pageToRedirect =
    directURL ||
    (level === 'first'
      ? '/home'
      : `${location.pathname
          .split('/')
          .slice(0, -1)
          .join('/')}`);
  const { setShowNavbar } = useContext(AppContext);

  useEffect(() => {
    setShowNavbar(level !== 'second');
  }, [level]);

  return (
    <PageHeading onClick={onClick}>
      <Link
        to={redirect ? pageToRedirect : null}
        onClick={e => {
          if (!redirect) e.preventDefault();
        }}
      >
        <IconStyled size={size} as={ArrowLeft} />
        <PageTitle size={size}>{title}</PageTitle>
      </Link>
    </PageHeading>
  );
};

NavChevron.propTypes = {
  title: PropTypes.string.isRequired,
  level: PropTypes.oneOf(['first', 'second']).isRequired,
  directURL: PropTypes.string,
  onClick: PropTypes.func,
  redirect: PropTypes.bool,
  size: PropTypes.string,
};

NavChevron.defaultProps = {
  directURL: null,
  onClick: () => {},
  redirect: true,
  size: null,
};

export default NavChevron;
